import { cn } from "@/lib/utils";
import { ExternalLinkIcon } from "lucide-react";

type ExternalLinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
};

export function ExternalLink({ className, href, children }: ExternalLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn("text-muted-foreground inline underline", className)}
    >
      {children}
      <ExternalLinkIcon className="mb-1 ml-1 inline" size={12} />
    </a>
  );
}
